import * as React from 'react';
import { createApiClient } from './client';
import { createCockpitApi, type CockpitApi } from './cockpit';

const ApiContext = React.createContext<CockpitApi | undefined>(undefined);

export function ApiProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const api = React.useMemo(() => {
    const client = createApiClient({});
    return createCockpitApi(client);
  }, []);
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

export function useCockpitApi(): CockpitApi {
  const ctx = React.useContext(ApiContext);
  if (!ctx) throw new Error('useCockpitApi must be inside ApiProvider');
  return ctx;
}
